import { useLocalStorage } from "usehooks-ts";

import Modal from "components/Modal";
import SwitchButton from "components/SwitchButton";

export default function DiscussionPageFocusModal({ onClose }: any) {
  const [excludeBots, setExcludeBots] = useLocalStorage<any>(
    "excludeBots",
    false
  );

  return (
    <Modal className="w-[600px]" onClose={onClose}>
      <div className="p-[20px]">
        <h2 className="text-[22px] font-medium pb-[8px] border-0 border-b border-solid  border-inactive-gray">
          Discussion Settings
        </h2>
        <div className="flex items-center justify-between py-[8px]">
          <div className="">
            <p className="mb-0 font-medium">Focused discussion only</p>
            <p className="mb-0 text-[13px]">
              Activate to hide automated discussions. These settings will apply
              to all discussion lists:
            </p>
          </div>
          <SwitchButton
            checked={excludeBots}
            onClick={() => setExcludeBots(!excludeBots)}
          ></SwitchButton>
        </div>
        <ul className="text-[13px]">
          <li>For Me</li>
          <li>Following</li>
          <li>All</li>
          <li>Posts & Mentions</li>
        </ul>
      </div>
    </Modal>
  );
}
